<template>
  <div id="wrapper">
    <div id="page-wrapper" class="light-gray-bg dashbard-1" v-if="isMatchPath">
      <article class="wrapper wrapper-content main-column full-column" v-if="searchOpen">
        <!-- ViewTitleBox -->
        <div class="ibox-tools view-title">
          <h1 class="info-menu view-name">
            <img src="static/img/assets/nav_report_on_2.png" alt="">
            {{$t('OKRReportStr')}}
          </h1>
          <span class="info-right">
          </span>
        </div>
        <div v-if="isLiteMode">
          <b-alert variant="danger" show>{{$t('liteIsStr')}}</b-alert>
        </div>
        <div v-else>
          <!-- /ViewTitleBox -->
          <b-col cols="4">
            <b-btn @click="setUserMe" variant="primary" class="mb-4">{{$t('displayMyselfStr')}}</b-btn>
          </b-col>
          <!-- ViewTitleBox -->
          <div class="ibox-tools view-title">
            <h1 class="info-menu view-name">
              <img src="static/img/assets/nav_people_on.png" alt="">
              {{$t('searchUserStr')}}
            </h1>
            <span class="info-right">
            </span>
          </div>
          <!-- /ViewTitleBox -->
          <section class="animated fadeInRight">
            <!-- 1on1item -->
            <div class="ibox">
              <div class="ibox-content">
                <!-- ユーザー検索ボックス -->
                <div class="ibox-title search-box">
                  <div class="row">
                    <div class="col-sm-12">
                      <form @submit.prevent>
                        <div class="input-group">
                          <input v-model="searchText" type="text" class="typeahead_2 form-control" :placeholder="$t('searchWithUserName')">
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <div class="ibox-content search-resultview">
                  <ul v-if="searchText == ''">
                    <li><label>{{$t('checkUserStrType')}}</label></li>
                    <li v-if="this.getVisitedUsers.length === 0" class="full-cell"><label>{{$t('notFoundUserStr')}}</label></li>

                    <template v-for="user in getVisitedUsers">
                      <li :key="user.id" v-if="user && user.userInfo && user.userId !== getUserId" class="result-box">
                        <div class="cursor" @click="setUserKey(user.userId)">
                          <span class="search-userimg">
                            <img v-if="user.userInfo.userIcon" :src="user.userInfo.userIcon" alt="image" class="img-circle">
                            <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                          </span>
                          <div class="search-userinfo">
                            <span class="search-username">{{ user.userInfo.userName }}</span>
                            <span class="search-userdept">{{ user.userInfo.dept }}</span>
                          </div>
                        </div>
                      </li>
                    </template>
                    <!-- </transition-group> -->
                  </ul>
                  <ul v-else>
                    <li><label>{{$t('searchResuleStrType')}}</label></li>
                    <li v-if="Object.keys(this.getUsersBySearchText).length === 0" class="full-cell"><label>{{$t('notFoundUserStr')}}</label></li>
                      <template v-for="(user, key) in getUsersBySearchText">
                        <li :key="user.id" v-if="user && user.userInfo && key !== getUserId" class="result-box">
                          <div class="cursor" @click="setUserKey(key)">
                            <span class="search-userimg">
                              <img v-if="user.userInfo.userIcon" :src="user.userInfo.userIcon" alt="image" class="img-circle">
                              <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                            </span>
                            <div class="search-userinfo">
                              <span class="search-username">{{ user.userInfo.userName }}</span>
                              <span class="search-userdept">{{ user.userInfo.dept }}</span>
                              <span class="search-userbio">{{ user.userInfo.userBio }}</span>
                            </div>
                          </div>
                        </li>
                      </template>
                    <!-- </transition-group> -->
                  </ul>
                </div>
                <!-- /ユーザー検索ボックス -->
              </div>
            </div>
            <!-- /1on1item -->
          </section>
        </div>
      </article>
      <!-- MainView -->
      <article class="wrapper wrapper-content main-column report-rel" v-if="!searchOpen">
        <div class="back-btn">
          <button @click="onClickBack" type="button" class="btn btn-primary block mb-4">{{$t('selectUserStr')}}</button>
        </div>
        <section class="animated fadeInUp trisection-wrap">
          <!-- <b-col cols="12"> -->
          <b-col cols="12">
            <div class="input-group date my-4 search-calendar">
              <ul class="input-searchType">
                <!-- <li class="input-group-addon text-right"> -->
                <li><input type="radio" id="due" v-model="searchType" value="dueDate"><label for="due">{{ $t('dueDateStr')}}</label></li>
                <li><input type="radio" id="start" v-model="searchType" value="startDate"><label for="start">{{ $t('startDateStr')}}</label></li>
                <li><input type="radio" id="active" v-model="searchType" value="active"><label for="active">{{ $t('activeStr')}}</label></li>
              </ul>
              <ul class="bg-info">
                <li v-if="searchType==='dueDate'">{{$t('dueDateAttentStr')}}</li>
                <li v-else-if="searchType==='startDate'">{{ $t('startDateAttentStr')}}</li>
                <li v-else-if="searchType==='active'">{{ $t('activeAttentStr')}}</li>
              </ul>
              <div class="select-date">
                <span class="input-group-addon text-right"><i class="fa fa-calendar" @click="openPickerFrom"></i></span>
                <datepicker
                :language="datepickerLocale[checkLanguage]"
                :format='format'
                :typeable='true'
                placeholder=""
                v-model="fromDate"
                ref="programaticOpenFrom"></datepicker>
                <span @click="clearDate('from')"><i class="fa fa-close"/></span>
                <span>　〜　</span>
                <span class="input-group-addon text-right"><i class="fa fa-calendar" @click="openPickerTo"></i></span>
                <datepicker
                :language="datepickerLocale[checkLanguage]"
                :format='format'
                :typeable='true'
                placeholder=""
                v-model="toDate"
                ref="programaticOpenTo"></datepicker>
                <span @click="clearDate('to')"><i class="fa fa-close"/></span>
              </div>
            </div>
          </b-col>
          <b-row class="trisection-head mx-0">
            <b-col cols="4" class="text-center">
              <div class="flex-box ibox-title bg-white">
                <h3 class="dir-title mg-right">{{$t('referenceSourceStr')}}</h3>
                <i class="fa fa-angle-double-left"></i>
              </div>
            </b-col>
            <b-col cols="4" class="">
              <div class="ibox-title bg-white">
                <span class="search-userimg">
                  <img v-if="targetUserInfo.userIcon" :src="targetUserInfo.userIcon" alt="image" class="img-circle">
                  <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                </span>
                <div class="search-userinfo">
                  <span class="search-username">{{ targetUserInfo.userName }}</span>
                  <span class="search-userdept">{{ targetUserInfo.dept }}</span>
                </div>
              </div>
            </b-col>
            <b-col cols="4" class="text-center">
              <div class="flex-box ibox-title bg-white">
                <i class="fa fa-angle-double-left mg-right"></i>
                <h3 class="dir-title">{{$t('referenceDestinationStr')}}</h3>
              </div>
            </b-col>
          </b-row>
          <b-row class="trisection mx-0 mt-4">
            <b-col cols="4" class="pt-2">
              <b-list-group>
                <template v-for="(relDstItem, idx) in relDst">
                  <report-relations-list-rel-item :key="idx" :dir="'dst'" :relItem="relDstItem" v-on:set-target="setTarget" v-on:open-detail="openDetail" :fromDate="fromDate" :toDate="toDate"/>
                </template>
              </b-list-group>
            </b-col>
            <b-col cols="4" id="rel-base" class="pt-2">
              <b-list-group :class="{ selected: targetOkrKey }">
                <template v-for="(itemOkr, idx) in getReports.listOkrs">
                  <b-list-group-item :key="idx" class="mb-4" :class="{ target: (targetOkrKey == itemOkr.itemId) }">
                    <div>
                      <report-relations-list-okr-item :item="itemOkr" :selectedKey="targetItemKey" v-on:set-item="setItem" v-on:open-detail="openDetail" :fromDate="fromDate" :toDate="toDate" :searchType="searchType" />
                    </div>
                  </b-list-group-item>
                </template>
              </b-list-group>
            </b-col>
            <b-col cols="4" class="pt-2">
              <b-list-group>
                <template v-for="(relSrcItem, idx) in relSrc">
                  <report-relations-list-rel-item :key="idx" :dir="'src'" :relItem="relSrcItem" v-on:set-target="setTarget" v-on:open-detail="openDetail" :fromDate="fromDate" :toDate="toDate"/>
                </template>
              </b-list-group>
            </b-col>
          </b-row>
          <!-- </b-col> -->
        </section>
      </article>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
// import Report1on1Item from '@/components/Report/Report1on1Item'
// import Datepicker from 'vuejs-datepicker'
import ReportRelationsListOkrItem from '@/components/Report/ReportRelationsListOkrItem'
import ReportRelationsListRelItem from '@/components/Report/ReportRelationsListRelItem'
import moment from 'moment'
import Vue from 'vue'
import Icon from 'vue-awesome'
import Datepicker from 'vuejs-datepicker'
import {i18n, liteMode} from '@/main.js'
import {ja, en, zh} from 'vuejs-datepicker/dist/locale'

export default {
  name: 'ReportRelations',
  components: {
    Icon,
    ReportRelationsListOkrItem,
    ReportRelationsListRelItem,
    Datepicker
  },
  data: function () {
    return {
      isLiteMode: liteMode,
      open: true,
      href: location.href,
      title: document.title,
      baseUser: '',
      baseItemKey: '',
      baseOkrKey: '',
      relSrc: [],
      relDst: [],
      searchType: 'dueDate',
      searchText: '',
      searchOpen: true,
      isManager: false,
      // fromDate: moment().subtract(1, 'month').toDate(),
      fromDate: moment().toDate(),
      toDate: moment().toDate(), // 絞り込む時にtoDateは現状は指定されていないのでとりあえず999年後にしておく
      format: 'yyyy/MM/dd',
      datepickerLocale: {
        ja: ja,
        en: en,
        zh_tr: zh
      }
    }
  },
  getters: {
  },
  computed: {
    isMatchPath () {
      return this.$route.name === 'ReportRelations'
    },
    checkLanguage () {
      return i18n.locale
    },
    targetUser: {
      get () {
        return this.baseUser
      },
      set (v) {
        this.baseUser = v
      }
    },
    targetItemKey: {
      get () {
        return this.baseItemKey
      },
      set (v) {
        this.baseItemKey = v
      }
    },
    targetOkrKey: {
      get () {
        return this.baseOkrKey
      },
      set (v) {
        this.baseOkrKey = v
      }
    },
    ...mapGetters([
      'getUserId',
      'getCurrentUser'
    ]),
    ...mapGetters('keyResults/', [
      'getKeyresultsByUserId',
      'getKeyresultById'
    ]),
    ...mapGetters('objectives/', [
      'getObjectivesByIds',
      'getObjectivesByUserId',
      'getObjectiveById'
    ]),
    ...mapGetters('_meta/', [
      'getMetaIsDeleted'
    ]),
    ...mapGetters('users/', [
      'getUsersByText',
      'getUsersByIds',
      'getUserInfoById'
    ]),
    getUsersBySearchText: function () {
      if (this.searchText.length === 0) {
        // return this.getUsers
        return {}
      } else {
        return this.getUsersByText(this.searchText)
      }
    },
    getVisitedUsers: function () {
      const currentUser = this.getCurrentUser
      console.log('currentUser', currentUser)
      if (currentUser && currentUser.hasOwnProperty('visitHistory')) {
        console.log('in if getVisit')
        // return this.getUsersByIds(Object.keys(currentUser.visitHistory))
        const visitHistory = Object.keys(currentUser.visitHistory || [])
        const recentlyCheckedUsers = this.getUsersByIds(Object.keys(currentUser.visitHistory))
        let sortedRecentlyCheckedUsers = visitHistory.sort((a, b) => { return currentUser.visitHistory[b] - currentUser.visitHistory[a] })
          .filter(key => !this.getMetaIsDeleted(key))
          .map(x => { return recentlyCheckedUsers[x] })
        return sortedRecentlyCheckedUsers
      } else {
        console.log('in else getVisit')
        return {}
      }
    },
    targetUserInfo () {
      return {
        userName: '（ユーザ名取得中）',
        userIcon: null,
        ...this.getUserInfoById(this.targetUser)
      }
    },
    getReports () {
      console.log(this.targetUser)
      // if (!this.targetUser) this.targetUser = this.$store.getters.getCurrentUserId
      const userId = this.targetUser
      console.log('reports:userId', userId)
      let reports = {
        listOkrs: []
      }
      let listOkrs = []
      let currObjs = this.getObjectivesByUserId(userId)
      let currKrs = this.getKeyresultsByUserId(userId)
      if (undefined !== currObjs) {
        this.relSrc = []
        this.relDst = []
        for (let k of Object.keys(currObjs)) {
          if (k === '.key' || k === '.value') {
            continue
          }
          if (!this.isBetweenDate(currObjs[k])) {
            continue
          }
          let c = currObjs[k]
          c.owner = this.getUserId
          let totalRels = 0
          if (!this.itemIsVisible(c)) {
            continue
          }
          c.itemId = k
          c.progress = Number(c.progress)
          if (isNaN(c.progress)) {
            c.progress = 0
          }
          c.date = moment(c.createdAt * 1000).format('YYYY-MM-DD')
          let relsObj = Object.keys(c.relations || {})
          let chkRelsObjKeys = {}
          c.numRelations = relsObj.length
          let numRelationsSrc = 0
          let numRelationsDst = 0
          for (let relObjKey of relsObj) {
            let rel = c.relations[relObjKey]
            let relCurrObjs = null
            if (rel.type === 'objectives') {
              relCurrObjs = this.getObjectivesByUserId(rel.userId)
            } else if (rel.type === 'keyresults') {
              relCurrObjs = this.getKeyresultsByUserId(rel.userId)
            }
            let relObj = relCurrObjs[rel.key]
            if (!this.isBetweenDate(relObj)) continue
            // console.log('ReportRelations:relObjs: ' + relObjKey, rel)
            if (!this.relItemIsVisible(rel)) {
              console.log('* Boo! Ignored rel.', rel)
              continue
            }
            if (!this.itemIsVisible(relObj)) {
              continue
            }
            let chkRelsObjKey = [rel.type, rel.userId, rel.key].join('_')
            if (relObjKey === '.key' || chkRelsObjKeys[chkRelsObjKey]) {
              console.log('* Boo! Ignored rel.:Duplicated', rel)
              continue
            }
            if (!!rel.dir && rel.dir === 'src') {
              numRelationsSrc++
              if (this.targetItemKey === k) {
                this.relSrc.push(rel)
              }
            } else {
              numRelationsDst++
              if (this.targetItemKey === k) {
                this.relDst.push(rel)
              }
            }
            chkRelsObjKeys[chkRelsObjKey] = true
          }
          Vue.set(c, 'numRelationsSrc', numRelationsSrc)
          Vue.set(c, 'numRelationsDst', numRelationsDst)
          totalRels += (c.numRelationsSrc + c.numRelationsDst)
          console.log('totalRels:Obj', totalRels)
          if (c.keyresults) {
            // console.log('c.keyresults', c.keyresults)
            for (let kr of Object.keys(c.keyresults)) {
              if (kr === '.key' || kr === '.value') continue
              // console.log('listOkrs:for KR', kr, c.keyresults[kr])
              if (currKrs[kr]) {
                currKrs[kr].owner = this.getUserId
                if (!this.itemIsVisible(currKrs[kr])) {
                  console.log('* Boo! Ignored.')
                  continue
                }
                if (!this.isBetweenDate(currKrs[kr])) {
                  continue
                }
                c.keyresults[kr] = currKrs[kr]
                c.keyresults[kr].itemId = kr
                c.keyresults[kr].progress = Number(c.keyresults[kr].progress)
                if (isNaN(c.keyresults[kr].progress)) {
                  c.keyresults[kr].progress = 0
                }
                c.keyresults[kr].date = moment(c.keyresults[kr].createdAt * 1000).format('YYYY-MM-DD')
                c.keyresults[kr].dueDate = c.keyresults[kr].dueDate
                c.keyresults[kr].startDate = c.keyresults[kr].startDate
                c.keyresults[kr].isOutdated = !this.isBetweenDate(currKrs[kr])
                let relsKr = Object.keys(c.keyresults[kr].relations || {})
                let chkRelsKrKeys = {}
                c.keyresults[kr].numRelations = relsKr.length
                let krnumRelationsSrc = 0
                let krnumRelationsDst = 0
                for (let relKrKey of relsKr) {
                  let rel = c.keyresults[kr].relations[relKrKey]
                  let relKeyCurrObjs = null
                  if (rel.type === 'objectives') {
                    relKeyCurrObjs = this.getObjectivesByUserId(rel.userId)
                  } else if (rel.type === 'keyresults') {
                    relKeyCurrObjs = this.getKeyresultsByUserId(rel.userId)
                  }
                  let relKeyObj = relKeyCurrObjs[rel.key]
                  if (!this.isBetweenDate(relKeyObj)) continue
                  // console.log('relKrs: ' + relKrKey, rel)
                  if (!this.relItemIsVisible(rel)) {
                    console.log('* Boo! Ignored rel.')
                    continue
                  }
                  if (!this.itemIsVisible(relKeyObj)) {
                    continue
                  }
                  let chkRelsKrKey = [rel.type, rel.userId, rel.key].join('_')
                  if (relKrKey === '.key' || chkRelsKrKeys[chkRelsKrKey]) {
                    console.log('* Boo! Ignored rel.:Duplicated', rel)
                    continue
                  }
                  if (!!rel.dir && rel.dir === 'src') {
                    krnumRelationsSrc++
                    if (this.targetItemKey === kr) {
                      this.relSrc.push(rel)
                    }
                  } else {
                    krnumRelationsDst++
                    if (this.targetItemKey === kr) {
                      this.relDst.push(rel)
                    }
                  }
                  chkRelsKrKeys[chkRelsKrKey] = true
                }
                Vue.set(c.keyresults[kr], 'numRelationsSrc', krnumRelationsSrc)
                Vue.set(c.keyresults[kr], 'numRelationsDst', krnumRelationsDst)
                totalRels += (c.keyresults[kr].numRelationsSrc + c.keyresults[kr].numRelationsDst)
              } else {
                delete c.keyresults[kr]
              }
            }
          }
          listOkrs.push(c)
        }
        listOkrs = listOkrs.sort((a, b) => {
          if (a.createdAt < b.createdAt) return -1
          if (a.createdAt > b.createdAt) return 1
          return 0
        })
        reports.listOkrs = listOkrs
      }
      console.log('reports:', reports)
      return reports
    }
  },
  created () {
    // this.$root.$on('bv::scrollspy::activate', this.onActivate)
  },
  watch: {
    searchType () {
      console.log('watch:searchType', this.searchType)
    }
  },
  methods: {
    ...mapActions('peoples', {
      setVisit: 'SET_VISIT_HISTORY'
    }),
    openPickerFrom: function () {
      this.$refs.programaticOpenFrom.showCalendar()
    },
    openPickerTo: function () {
      this.$refs.programaticOpenTo.showCalendar()
    },
    isBetweenDate (item) {
      if (!item || !Object.keys(item).length) { return false }
      let dueDate = moment(item.dueDate || 0).format('YYYYMMDD')
      let startDate = item.startDate ? moment(item.startDate || 0).format('YYYYMMDD') : moment(item.dueDate || 0).format('YYYYMMDD')
      let fromDate = moment(this.fromDate).format('YYYYMMDD')
      let toDate = moment(this.toDate).format('YYYYMMDD')
      switch (this.searchType) {
        case 'dueDate':
          return (this.fromDate ? dueDate >= fromDate : true) && (this.toDate ? dueDate <= toDate : true)
        case 'startDate':
          return (this.fromDate ? startDate >= fromDate : true) && (this.toDate ? startDate <= toDate : true)
        case 'active':
          return (this.fromDate ? dueDate >= fromDate : true) && (this.toDate ? startDate <= toDate : true)
      }
    },
    setItem (val) {
      console.log('setItem: ', val)
      this.targetItemKey = val.itemId
      this.targetOkrKey = val.parentObjId || val.itemId
      console.log('setItem: ', this.targetItemKey, this.targetOkrKey)
    },
    setTarget (val, ev) {
      console.log('setTarget: ', val, ev)
      this.setUserKey(val.userId)
      this.setItem(val)
      console.log('setTarget: ', this.targetUser, this.targetItemKey, this.targetOkrKey)
    },
    onClickBack () {
      this.open = false
      this.searchOpen = true
    },
    setUserKey (userKey) {
      this.targetUser = userKey
      this.open = true
      this.searchOpen = false
      if (this.getUserId !== userKey) { this.setVisit(userKey) }
    },
    setUserMe () {
      this.setUserKey(this.getUserId)
      // this.setUserKey(this.$store.getters.getCurrentUserId)
    },
    openDetail: function (value) {
      this.$router.push({ name: 'User', params: { userId: value.userId || this.targetUser, item: value.type } })
    },
    relItemIsVisible: function (key) {
      // const rel = this.getObjectivesByUserId(key)
      let rel
      switch ((key || {}).type) {
        case 'objectives':
          rel = this.getObjectiveById(key.key, key.userId)
          rel.owner = key.userId
          break
        case 'keyresults':
          rel = this.getKeyresultById(key.key, key.userId)
          rel.owner = key.userId
          break
        default:
          console.log('ReportRelations:relItemIsVisible: Unknown type.')
          return false
      }
      return Object.keys(rel).length ? this.itemIsVisible(rel) : false
    },
    itemIsVisible: function (item) {
      const me = this.getCurrentUser
      if (item) {
        if (item.hasOwnProperty('owner') && (item.owner === this.getUserId)) {
          return true
        }
        if (!item.hasOwnProperty('limitedAccess')) {
          return true
        }
        if (item.limitedAccess.hasOwnProperty('limitedUsers')) {
          if (item.limitedAccess.limitedUsers.hasOwnProperty(this.getUserId)) {
            return true
          }
        }
        if (item.limitedAccess.hasOwnProperty('limitedGroups')) {
          if (me.hasOwnProperty('groups')) {
            return Object.keys(item.limitedAccess.limitedGroups).some(x => me.groups.hasOwnProperty(x))
          }
        }
      }
      return false
    },
    clearDate: function (type) {
      if (type === 'from') {
        this.fromDate = ''
      } else {
        this.toDate = ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
h4.date-label {
  font-size: 150%;
}
.input-searchType {
  margin: auto 0;
  display: -webkit-inline-box;
  padding-inline-start:1px;
  li:not(:first-child) {
    margin-left: 35px;
  }
  input[type="radio"]~label {
    margin-left: 5px;
  }
}
.search-calendar {
  display: inline-block;
  padding-inline-start:18px;
}
.select-date {
  display: flex;
  margin: auto 0;
}
.report-rel {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.back-btn {
  height: 2.5em;
}
.trisection-wrap {
  height: calc(100% - 5.5em);
}
.trisection-head {
  height: 5em;
}
.trisection {
  height: calc(100% - 7.5em);
  &>div {
    overflow-y: auto;
    // height: calc(72vh);
    height: 100%;
    word-wrap: break-word;
  }
}
.selected {
  .okrItem {
    opacity: .5;
  }
  .target {
    box-shadow: 0 0 .1em .2em #ffcccc;
    .okrItem {
      opacity: 1;
    }
  }
}
.dir-title {
  height: 100%;
  max-height: 6.8rem;
  border: none;
  color: #3e8fe0;
  line-height: 4rem;
}
.trisection-head .flex-box {
  width: 100%;
  align-items: center;
}
.mg-right {
    margin-right: 2rem;
    margin-left: 1rem;
}
.fa-angle-double-left {
  font-size: 1.7em;
  // vertical-align: middle;
}
.bg-info {
      font-size: 12.5px;
      width: 475px;
}
</style>



// WEBPACK FOOTER //
// src/views/report/ReportRelations.vue